import { render, staticRenderFns } from "./homeMenu.vue?vue&type=template&id=befd0b5a&"
import script from "./homeMenu.js?vue&type=script&lang=js&"
export * from "./homeMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports